import { VerticalContainer } from '@american-autonomy/ag-ui';

import CaptionText from 'components/text/CaptionText';

import {
    CENTER,
    FILL_COLOR_VARIABLE,
    FULL_PERCENT,
    MINIMUM_PERCENT,
    PERCENT_SYMBOL,
    RADIUS,
    TEST_ID,
    VIEW_BOX_SIZE
} from './constants';
import getFillColor from './getFillColor';
import type { CSSProperties, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DonutChart: FunctionComponent<Props> = ({
    className = '',
    colorMap,
    label = '',
    percent,
    testId = TEST_ID
}) => {
    const filledPercent = Math.min(Math.max(percent, MINIMUM_PERCENT), FULL_PERCENT);
    const fillColor = colorMap && getFillColor({ colorMap, percent: filledPercent });
    const fillColorStyle = fillColor
        ? ({ [FILL_COLOR_VARIABLE]: fillColor } as CSSProperties)
        : undefined;

    return (
        <VerticalContainer className={`${className} ${styles.donutChart}`} testId={testId}>
            <svg
                className={styles.chart}
                style={fillColorStyle}
                viewBox={`0 0 ${VIEW_BOX_SIZE} ${VIEW_BOX_SIZE}`}
                xmlns='http://www.w3.org/2000/svg'>
                <circle
                    className={styles.track}
                    cx={CENTER}
                    cy={CENTER}
                    pathLength={FULL_PERCENT}
                    r={RADIUS}
                />

                {filledPercent > MINIMUM_PERCENT && (
                    <circle
                        className={styles.fill}
                        cx={CENTER}
                        cy={CENTER}
                        pathLength={FULL_PERCENT}
                        r={RADIUS}
                        strokeDasharray={`${filledPercent} ${FULL_PERCENT - filledPercent}`}
                    />
                )}
            </svg>

            {label && <CaptionText className={styles.label} text={label} />}

            <CaptionText className={styles.value} text={`${percent}${PERCENT_SYMBOL}`} />
        </VerticalContainer>
    );
};

export default DonutChart;
